import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/products/containers')({
  staticData: {
    permissionSection: 'settings',
    section: 'Columns',
    breadcrumb: 'Containers',
    clearParentBreadcrumbs: true,
  },
  component: Outlet,
});
